<template>

  <form name="form-upload-presentation-file" id="form-upload-presentation-file" @submit="onSubmit">
    <input type="hidden" name="id" v-model="model.id">
    <input type="hidden" name="eventDetailId" v-model="model.eventDetailId">

    <div class="form-row">

      <div class="col-md-12">
        <div class="form-group">
          <label for="speakerId">Speaker Name</label>
          <small class="form-text text-muted mb-1">Leave empty if the speaker is not confirmed yet — the topic is shown as TBA.</small>

          <SearchableSelect
            inputId="speakerId"
            v-model="model.speakerId"
            :options="speakerOptions"
            optionLabel="label"
            optionValue="value"
            placeholder="TBA"
            empty-message="No speaker by that name. Add them on the Speaker page first."
          />
        </div>

        <div class="form-group">
          <label for="topic">Topic</label>
          <Textarea class="form-control" v-model="model.topic" id="topic" rows="5"></Textarea>
        </div>

        <div class="form-group">
          <label for="orderNumber">Priority</label>
          <InputText class="form-control" v-model="model.orderNumber" id="orderNumber" type="number"></InputText>
        </div>

      </div>

    </div>

    <div class="d-flex justify-content-end mb-sm-1">
      <button type="button" class="btn btn-outline-secondary mr-sm-1" @click="onCancel">Cancel</button>
      <button type="submit" class="btn btn-primary" :disabled="saving">{{ model.id ? 'Save topic' : 'Add topic' }}</button>
    </div>

  </form>


</template>

<script>
import apiService from "@/services/ApiService";
import Textarea from "primevue/textarea";
import InputText from "primevue/inputtext";
import SearchableSelect from "@/components/shared/SearchableSelect.vue";

export default {
  name: "EventDetailAddSpeakerForm",
  components: {
     Textarea, InputText, SearchableSelect
  },
  props: {
    eventDetail: {
      type: Object,
      required: true
    },
    speaker: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      model: {
        eventDetailId: '',
        speakerId: '',
        topic: '',
        orderNumber: '',
        id: ''
      },
      saving: false,
      speakerOptions: [],
    }
  },

  methods: {
    onSubmit(event) {
      event.preventDefault();

      this.saving = true;

      let url = '/eventdetail/add-speaker';
      let successMessage = this.model.id ? 'Topic has been saved' : 'Topic has been added';
      let errorMessage = this.model.id ? 'Failed to save topic' : 'Failed to add topic';

      apiService.post(url, this.model)
          .then(() => {

            this.$emit('onSubmitAddSpeaker');

            this.$toast.add({
              severity: 'success',
              summary: 'Success',
              detail: successMessage,
              life: 5000
            });
          })
          .catch(error => {
            console.log(error);
            this.$toast.add({
              severity: 'error',
              summary: errorMessage,
              detail: error.response.data.Message,
              life: 5000
            });
          })
          .finally(() => {
            this.saving = false;
          });
    },
    onCancel() {
      console.log('on cancel add topic');
      this.$emit('onCancelAddSpeaker');
    },
    getSpeakers() {
      apiService.get('/eventdetail/speakers')
          .then(response => {
            this.speakerOptions = response.data;
          }).catch(error => {
        console.error(error);
        this.$toast.add({
          severity: 'error',
          summary: 'Error',
          detail: error.response.data.Message,
          life: 5000
        });
      });
    }
  },
  mounted() {
    this.model.eventDetailId = this.eventDetail.id;
    this.getSpeakers();
    if(this.speaker){
      this.model.speakerId = this.speaker.id;
      this.model.topic = this.speaker.topic;
      this.model.orderNumber = this.speaker.orderNumber;
      this.model.id = this.speaker.eventDetailSpeakerId;
    }
  }
}
</script>


<style scoped>

</style>
